import React from 'react'

import { memo } from 'react'

export default memo(function InputMask ({ ...props })
{
	const letters = Array.from(props.value).map(function (letter, i)
	{
		return (
			// eslint-disable-next-line react/no-array-index-key
			<span key={ 'i-' + i + '-l-' + letter }
				className={ props.className + '__letter' }
				aria-hidden={ props.hide > i }>
				{ letter }
			</span>
		);
	});

	let class_name = props.className || '';

	return (
		<span className={ class_name }>
			{ letters }
		</span>
	);
});